<template>
  <form v-if="currentResource" class="qm-panel" v-on:change="updateResource">
    <div class="row">
      <div class="col-6 col-sm-6 col-md-2 mb-2">
        <div class="form form-inline">
          <label for="qm-input-date" class="col-form-label hidden-lg-up qm-resource-label">Day</label>
          <input v-model="currentResource.date" type="text" id="qm-input-date" class="form-control qm-input-date">
        </div>
      </div>
      <div class="col-6 col-sm-6 col-md-2">
        <div class="form form-inline">
          <label for="qm-input-time" class="col-form-label hidden-lg-up qm-resource-label">Time</label>
          <input v-model="currentResource.time" type="text" id="qm-input-time" class="form-control qm-input-time">
        </div>
      </div>
      <div class="col-6 col-sm-8 col-md-3 mb-2">
        <div class="form form-inline">
          <label for="qm-name-vehicletype-select" class="col-form-label hidden-lg-up qm-vehicletype-label">Vehicle type</label>
          <select v-if="vehicleTypesOptions.length > 0" v-model="currentResource.vehicleTypeId" class="custom-select" id="qm-name-vehicletype-select">
            <option v-for="option in vehicleTypesOptions" v-bind:value="option.id">{{ option.text }}</option>
          </select>
        </div>
      </div>
      <div class="col-6 col-sm-4 col-md-1">
        <div class="form-check qm-checkbox-trailer">
            <label class="form-check-label">
                <input class="form-check-input" type="checkbox" v-model="currentResource.trailer">
                Trailer
            </label>
          </div>
      </div>
      <div class="col-4 col-md-1">
        <div class="form form-inline">
          <label for="qm-input-packer" class="col-form-label hidden-lg-up qm-resource-number-label">Packer</label>
          <input v-model="currentResource.packer" type="number" id="qm-input-packer" class="form-control qm-resource-number">
        </div>
      </div>
      <div class="col-4 col-md-1">
        <div class="form form-inline">
          <label for="qm-input-fitter" class="col-form-label hidden-lg-up qm-resource-number-label">Fitter</label>
          <input v-model="currentResource.fitter" type="number" id="qm-input-fitter" class="form-control qm-resource-number">
        </div>
      </div>
      <div class="col-4 col-md-1">
        <div class="form form-inline">
          <label for="qm-input-porter" class="col-form-label hidden-lg-up qm-resource-number-label">Porter</label>
          <input v-model="currentResource.porter" type="number" id="qm-input-porter" class="form-control qm-resource-number">
        </div>
      </div>
      <div class="col-4 col-md-1 mb-3"></div>
    </div>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Resource',
  data: () => ({
    currentResource: {}
  }),
  props: ['resource'],
  computed: {
    ...mapGetters({
      session: 'getSession',
      vehicleTypesOptions: 'getAllVehicleTypes'
    }),
    resourceStorageKey () {
      return 'survey-' + this.session.surveyId + '-resource-' + this.resource.resourceId
    }
  },
  created: function () {
    this.$store.dispatch('loadSession').then(() => {
      this.$store.dispatch('loadAllVehicleTypes').then(() => {
        this.currentResource = this.resource
      })
    })
  },
  methods: {
    updateResource () {
      this.$store.dispatch('updateResource', {
        storageKey: this.resourceStorageKey,
        resource: this.currentResource
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/children/Resource.vue